import React, { useEffect} from "react";
import { BiPlusCircle } from "react-icons/bi";
import { Fancybox as NativeFancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import Breadcrumb from "../common/Breadcrumb";

const HappyLohri = () => {  

  const images = [
    { id: 1, src: "images/holi/holi-1.png", alt: "HappyLohri", title: "HappyLohri", group: "HappyLohri" },
    { id: 2, src: "images/holi/holi-2.png", alt: "HappyLohri", title: "HappyLohri", group: "HappyLohri" },
    { id: 3, src: "images/holi/holi-3.png", alt: "HappyLohri", title: "HappyLohri", group: "HappyLohri" },
    { id: 4, src: "images/holi/holi-4.png", alt: "HappyLohri", title: "HappyLohri", group: "HappyLohri" },
     { id: 5, src: "images/holi/holi-5.png", alt: "HappyLohri", title: "HappyLohri", group: "HappyLohri" },
      { id: 6, src: "images/holi/holi-6.png", alt: "HappyLohri", title: "HappyLohri", group: "HappyLohri" },
       { id: 7, src: "images/holi/holi-7.png", alt: "HappyLohri", title: "HappyLohri", group: "HappyLohri" },
        { id: 8, src: "images/holi/holi-8.png", alt: "HappyLohri", title: "HappyLohri", group: "HappyLohri" },
         { id: 9, src: "images/holi/holi-9.png", alt: "HappyLohri", title: "HappyLohri", group: "HappyLohri" },
  ];

  useEffect(() => {
    NativeFancybox.bind("[data-fancybox='gallery']", {
      infinite: true,
      Toolbar: {
        display: {
          left: ["infobar"],
          right: ["slideshow", "thumbs", "close"],
        },
      },
      Thumbs: {
        autoStart: false,
      },
      caption: (fancybox, slide) => {
        return slide.$trigger?.dataset?.caption || slide.$trigger?.title || "";
      },
    });

    return () => {
      NativeFancybox.destroy();
    };
  }, []);


  return (
    <>
      <Breadcrumb
        pageTitle="Gallery"
        breadcrumbItems={[
          { label: "Home", link: "/" },
          { label: "Happy Lohri 2026" },
        ]}
        backgroundImage="images/banner/slide-2.png"
      />

      <section className="space-ptb">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12 text-center">
              <div className="section-title">
                <h2>Happy Lohri 2026</h2>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="my-shuffle-container row columns-4 popup-gallery full-screen">
                {images.map((image) => (
                  <div key={image.id} className="grid-item" data-group={image.group}>
                    <div className="portfolio-item">
                      <div className="position-relative">
                        <img
                          className="img-fluid"
                          src={image.src}
                          alt={image.alt}
                          loading="lazy"
                        />
                        <div className="portfolio-overlay">
                          <a
                            data-fancybox="gallery"
                            data-caption={image.title}
                            href={image.src}
                            title={image.title}
                            className="portfolio-img"
                          >
                            <i>
                              <BiPlusCircle size={40} />
                            </i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HappyLohri;
